import { registerWidget } from "dmeditor";
import definition from "./definition";
import { ClubDropdown, onServerSideLoad } from "./ClubDropdown";

const register = () => {
  registerWidget(definition, {
    render: ClubDropdown,
    onServerSideLoad: onServerSideLoad,
  });
};

export default register;
